import Api from "~/service/Api";

class FlyerRepository {
  getOne(tourId) {
    return Api.get(`/flyers/${tourId}`);
  }

  update(tourId, data) {
    return Api.post(`/flyers/${tourId}`, data);
  }
}

export default FlyerRepository;
